/**
 * @generated SignedSource<<98714d374b0d207a67258395cf7d5667>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileConnectionSortDirectionField = "ASC" | "DESC";
export type FileConnectionSortField = "ACCESSED_COUNT" | "CREATED_AT" | "LAST_ACCESSED_AT" | "NAME" | "SIZE";
export type WorkspaceFilesQuery$variables = {
  after?: string | null;
  first?: number | null;
  order?: FileConnectionSortDirectionField | null;
  orderBy?: FileConnectionSortField | null;
  workspaceId: string;
};
export type WorkspaceFilesQuery$data = {
  readonly workspace: {
    readonly " $fragmentSpreads": FragmentRefs<"FileUploadAreaWorkspace_workspace" | "WorkspaceFilesList_Workspace">;
  };
};
export type WorkspaceFilesQuery = {
  response: WorkspaceFilesQuery$data;
  variables: WorkspaceFilesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceFilesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FileUploadAreaWorkspace_workspace"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceFilesList_Workspace"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceFilesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "FilesConnection",
            "kind": "LinkedField",
            "name": "files",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilesConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnzonedDate",
                        "kind": "LinkedField",
                        "name": "createdAtDate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isoString",
                                "storageKey": null
                              }
                            ],
                            "type": "Date",
                            "abstractKey": "__isDate"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOrg",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "filters": [
              "orderBy",
              "order"
            ],
            "handle": "connection",
            "key": "WorkspaceFilesList__files",
            "kind": "LinkedHandle",
            "name": "files"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "508decce2b90c7192e7b5c4d2c8882cf",
    "id": null,
    "metadata": {},
    "name": "WorkspaceFilesQuery",
    "operationKind": "query",
    "text": "query WorkspaceFilesQuery(\n  $first: Int\n  $after: String\n  $orderBy: FileConnectionSortField\n  $order: FileConnectionSortDirectionField\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    ...FileUploadAreaWorkspace_workspace\n    ...WorkspaceFilesList_Workspace\n    id\n  }\n}\n\nfragment FileIconBox_file on File {\n  type\n  isOrg\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FileUploadAreaWorkspace_workspace on Workspace {\n  id\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceFilesFile_file on File {\n  id\n  name\n  url\n  type\n  formattedSize\n  createdAtDate {\n    ...FormattedDate\n  }\n  ...FileIconBox_file\n}\n\nfragment WorkspaceFilesList_Workspace on Workspace {\n  id\n  files(first: $first, after: $after, orderBy: $orderBy, order: $order) {\n    edges {\n      node {\n        id\n        ...WorkspaceFilesFile_file\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "929b041bf5d8d4811b66b021cfe513cc";

export default node;
